module.exports = __webpack_public_path__ + "static/media/girl.d24a695f.jpg";